var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99967 0.666664C1.08301 0.666664 0.341341 1.41666 0.341341 2.33333L0.333008 15.6667C0.333008 16.5833 1.07467 17.3333 1.99134 17.3333H11.9997C12.9163 17.3333 13.6663 16.5833 13.6663 15.6667V5.66666L8.66634 0.666664H1.99967ZM7.83301 6.5V1.91666L12.4163 6.5H7.83301Z",
    fill: "#B12D84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.1a3c27fad5767adc8b8a4bcbfe784396.svg";
export { ForwardRef as ReactComponent };